<template>
    <page-shell
        v-if="locations.length> 0 && experiences.length > 0"
        title="Bookings"
    >
        <booking-overview
            :locations="locations"
            :experiences="experiences"
            :past="past"
        />
    </page-shell>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router/composables";
import { getUserLocationsSimple } from "../../api/graphql/locations";
import { getExperiencesSimple } from "../../api/graphql/experiences";
import BookingOverview from "../booking/Overview.vue";
import PageShell from "../shared/PageShell.vue";

const locations = ref([]);
const experiences = ref([]);

const route = useRoute();
const past = computed(() => route.query.past === "true");

const updateLocations = async () => {
    locations.value = await getUserLocationsSimple();
};

const updateExperiences = async () => {
    experiences.value = await getExperiencesSimple();
};

onMounted(() => {
    updateLocations();
    updateExperiences();
});
</script>

<style>
</style>